import { axiosInstanceExporters } from "./";

const transactionsList = async ({ params }) =>
  await axiosInstanceExporters.get(
    "/api/Transaction/GetAdminTransactions",
    {
      params,
      paramsSerializer: { indexes: null }
    }
  );

export { transactionsList };
